import React, { createContext, useContext, useState, useEffect } from "react";
import { loginTenant } from "../api/auth";

type AuthContextValue = {
    user: any;
    token: string | null;
    login: (email: string, password: string, subdomain: string) => Promise<boolean>;
    logout: () => void;
    isAuthenticated: boolean;
    message: string;
};

const AuthContext = createContext<AuthContextValue | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<any>(null);
    const [message, setMessage] = useState("");
    const [token, setToken] = useState<string | null>(null);

    // Restore session from localStorage
    useEffect(() => {
        const savedToken = localStorage.getItem("authToken");
        const savedUser = localStorage.getItem("user");

        if (savedToken && savedUser) {
            setToken(savedToken);
            setUser(JSON.parse(savedUser));
        }
    }, []);

    const login = async (email: string, password: string, subdomain: string) => {
        const res = await loginTenant(email, password, subdomain);
        if (!res.role || res.role.name !== 'admin') {
            setMessage("You are not authorized to access this panel.")
            console.log("message", message)
            return false;
        } else {
            setToken(res.token);
            setUser(res.user);
            localStorage.setItem("authToken", res.token);
            localStorage.setItem("user", JSON.stringify(res));
            await new Promise(resolve => setTimeout(resolve, 3000));
            setMessage("Logged in successfully!")
            window.location.href = "/dashboard";
            return true;
        }
    };

    const logout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        localStorage.removeItem("subdomain");
        setToken(null);
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                token,
                login,
                logout,
                isAuthenticated: !!token,
                message
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
};
